import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash-es/noop';
import Panel from '../../../Panel';
import TextInput from '../../../../Form/TextInput';
import { getFeatureDisplayString } from '../../../../../lib/features';

export default function FeatureTitleEditor(props) {
  return (
    <Panel
      title={`${getFeatureDisplayString(props.feature.properties.ghType)} Name`}
      divider={true}
    >
      <TextInput
        fullWidth
        onChange={props.onChange}
        value={props.feature.title}
      />
    </Panel>
  );
}

FeatureTitleEditor.propTypes = {
  feature: PropTypes.object,
  onChange: PropTypes.func,
};

FeatureTitleEditor.defaultProps = {
  onChange: noop
};
